/* eslint-disable react-hooks/exhaustive-deps */
import React, {memo, useMemo, useContext} from "react";
import {useGetAssetsInfiniteQuery} from "hooks";
import ItemDragDimmed from "components/AssetLibrary/ItemDragDimmed";
import ExpandedList from "components/Layout/components/ObjectPanel/ExpandedList";
import useDragAndDropAsset from "components/Layout/components/ObjectPanel/hooks/useDragAndDropAsset";
import UploadHelper from "../UploadHelper";
import {ASSET_PARAMS} from "components/Layout/constants";
import {
  UploadingAssetDispatchContext,
  UploadProgressDispatchContext,
} from "components/Layout/components/ObjectPanel/UploadProgressProvider";
import styles from "./index.module.scss";

function AssetTab({listType, currentType, setCurrentType}) {
  const setUploadProgress = useContext(UploadProgressDispatchContext);
  const setUploadingAssetInfo = useContext(UploadingAssetDispatchContext);
  const {handleDropMyAsset, handleDragOverMyAsset, handleDragEnterMyAsset, handleDragLeaveMyAsset, isMyAssetDroppable} =
    useDragAndDropAsset(setUploadProgress.updateUploadProgress, setUploadingAssetInfo.updateUploadingAssetInfo);
  const {data, fetchNextPage, hasNextPage} = useGetAssetsInfiniteQuery({
    ...ASSET_PARAMS[currentType],
    publicStatus: false,
    offset: 0,
    limit: 10,
  });
  const assetlist = useMemo(() => data, [data]);
  const memoizedData = useMemo(() => data, [data]);
  const memoizedFetchNextPage = useMemo(() => fetchNextPage, []);
  const memoizedHasNextPage = useMemo(() => hasNextPage, [hasNextPage]);

  return (
    <div className={styles.container} onDragEnter={handleDragEnterMyAsset}>
      {isMyAssetDroppable && (
        <ItemDragDimmed
          onDrop={e => handleDropMyAsset(e, setCurrentType)}
          onDragOver={handleDragOverMyAsset}
          onDragLeave={handleDragLeaveMyAsset}
        />
      )}
      {memoizedData?.pages[0]?.length > 0 ? (
        <ExpandedList listType={listType} data={assetlist} fetchNextPage={memoizedFetchNextPage} hasNextPage={memoizedHasNextPage} />
      ) : (
        <UploadHelper />
      )}
    </div>
  );
}

export default memo(AssetTab);
